module.exports = __webpack_public_path__ + "img/unitPriceEvaluation_fluctuation_01.1d9e9a2a.png";